/* eslint-disable no-use-before-define */
/* eslint-disable import/no-extraneous-dependencies */
import React, { memo, useMemo, useState, createRef, useEffect, useRef } from "react";
import Slider from "react-slick";
import "@qlik/qlik/src/assets/vendor/slick/slick.css";
import "@qlik/qlik/src/assets/vendor/slick/slick-theme.css";
import CustomerSliderCard from "./CustomerSliderCard";
import * as styles from "./styles.module.css";
import Cta from "@qlik/qlik/src/components/Cta";
import { filterValidCta } from "@qlik/qlik/src/lib/util/helpers";

const CustomerCardSliderDekstop = memo(({ cards }) => {
    const [cardRefs, setCardRefs] = useState([]);
    const [isSliderChanged, setIsSliderChanged] = useState(false);
    const [activeSlide, setActiveSlide] = useState(0);
    const sliderRef = useRef(null);

    /**
     * Groups the cards into chunks of 8
     */
    const groups = useMemo(() => {
        const chunkSize = 1;
        const data = [];
        for (let i = 0; i < cards.length; i += chunkSize) {
            const chunk = cards.slice(i, i + chunkSize);
            data.push(chunk);
        }
        // Create refs for each card and group
        setCardRefs(() =>
            Array(cards.length)
                .fill()
                .map(() => createRef())
        );
        return data;
    }, [cards]);

    /**
     * Handles hover event on a card
     * @param {number} gIndex - Group index
     * @param {number} cIndex - Card index within the group
     */
    const onHoverHandler = (cIndex) => {
        const position = cIndex - activeSlide;

        if (position === 0 || position === 1) {
            const next = cardRefs[cIndex + 1];
            const after = cardRefs[cIndex + 2];
            const last = cardRefs[cIndex + 3];
            next?.current.classList.add("move-right");
            after?.current.classList.add("move-right");
            last?.current.classList.add("move-right");
        }

        if (position === 2 || position === 3) {
            const prev = cardRefs[cIndex - 1];
            const before = cardRefs[cIndex - 2];
            const last = cardRefs[cIndex + -3];
            prev?.current.classList.add("move-left");
            before?.current.classList.add("move-left");
            last?.current.classList.add("move-left");
        }

        const { classList } = sliderRef.current.querySelector(".slick-list");

        if (position === 0) {
            classList.add("move-block-right");
            classList.remove("move-block-left");
        }
        if (position === 1) {
            classList.remove("move-block-left");
            classList.remove("move-block-right");
        }
        if (position === 2) {
            classList.remove("move-block-left");
            classList.remove("move-block-right");
        }

        if (position === 3) {
            classList.add("move-block-left");
            classList.remove("move-block-right");
        }
    };

    /**
     * Handles hover removal event on a card
     * @param {number} gIndex - Group index
     * @param {number} cIndex - Card index within the group
     */
    const onHoverRemoveHandler = (cIndex) => {
        const position = cIndex - activeSlide;

        if (position === 0 || position === 1) {
            const next = cardRefs[cIndex + 1];
            const after = cardRefs[cIndex + 2];
            const last = cardRefs[cIndex + 3];
            next?.current.classList.remove("move-right");
            after?.current.classList.remove("move-right");
            last?.current.classList.remove("move-right");
        }

        if (position === 2 || position === 3) {
            const prev = cardRefs[cIndex - 1];
            const before = cardRefs[cIndex - 2];
            const last = cardRefs[cIndex + -3];
            prev?.current.classList.remove("move-left");
            before?.current.classList.remove("move-left");
            last?.current.classList.remove("move-left");
        }
    };

    useEffect(() => {
        const activeSliders = document.querySelectorAll(".slick-active .card-item");
        activeSliders.forEach((item, i) => {
            if (i === 2 || i === 3) {
                item.classList.add("float-right");
            } else {
                item.classList.remove("float-right");
            }
        });
    }, [isSliderChanged]);

    // Render the component
    return (
        <div className="container">
            <div className="lg:-mx-[204px] lg:pb-20" ref={sliderRef}>
                <Slider
                    className={`w-full slider-cards slick-arrow-top-right lg:ml-5 ${styles.customerSliderCard}`}
                    infinite={false}
                    arrows
                    slidesToShow={4}
                    slidesToScroll={1}
                    duration={1000}
                    beforeChange={(oldIndex, newIndex) => {
                        setIsSliderChanged(!isSliderChanged);
                        setActiveSlide(newIndex);
                    }}
                >
                    {groups?.map((group, gIndex) => (
                        <div className="transition-all ease-out duration-1000" key={gIndex}>
                            {group?.map((card, index) => {
                                let ctaList = filterValidCta(card?.cta ?? []);
                                return (
                                    <div
                                        key={card.id}
                                        ref={cardRefs[gIndex + index]}
                                        className="lg:w-[279px] xl:w-87.5 relative transition-all ease-out duration-700"
                                        role="button"
                                        onMouseEnter={() => onHoverHandler(gIndex)}
                                        onMouseLeave={() => onHoverRemoveHandler(gIndex)}
                                    >
                                        {card?.cta ? (
                                            <Cta
                                                data={ctaList?.[0]}
                                                className={`after:hidden card-item ${styles.customerClickableCard}`}
                                            >
                                                <CustomerSliderCard card={card} key={card.id} type="desktop" />
                                            </Cta>
                                        ) : (
                                            <CustomerSliderCard
                                                card={card}
                                                key={card.id}
                                                type="desktop"
                                                className="card-item"
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
});

export default CustomerCardSliderDekstop;
